import { render, staticRenderFns } from "./InvoiceViewGlobal.vue?vue&type=template&id=350262ea&"
import script from "./InvoiceViewGlobal.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports